import React, { useContext } from "react";
import {
    ProductOverviewCards,
    ProductConversionFunnel,
    ProductRoasSpendWidget,
    ProductCampaignsWidget,
    ProductKeywordsWidget,
    ProductTrendAnalysisWidget,
    RatingsAndReviewsWidget,
    ProductAnalysisWidget
} from "@components/widgets";
import {
    IDeepDiveModalConfig,
    IMainContext,
    ProductDeepdiveModules,
    TCommonRowData,
    TPaModuleLoadingState,
} from "@ts/common-types";
import { GridApi } from "ag-grid-community";
import WidgetModuleLayout from "./WidgetModuleLayout";
import { mainContext } from "@/ts/constants";

interface ProductAnalysisOverviewModule {
    loadingState: TPaModuleLoadingState;
    moduleData: IDeepDiveModalConfig;
    rowData: TCommonRowData;
    setRowData: React.Dispatch<React.SetStateAction<TCommonRowData>>;
    gridApi: GridApi;
    setGridApi: React.Dispatch<React.SetStateAction<GridApi>>;
}
const ProductAnalysisOverviewModule: React.FC<ProductAnalysisOverviewModule> = (
    props
) => {
    const { loadingState, moduleData } = props;

    return (
        <WidgetModuleLayout loaderCondition={loadingState?.[ProductDeepdiveModules.OVERVIEW]}>
            <ProductOverviewCards widgetData={moduleData} />
            <ProductConversionFunnel widgetData={moduleData} />
            <ProductRoasSpendWidget widgetData={moduleData.spendRoasData} />
            <ProductCampaignsWidget />
            <ProductKeywordsWidget {...props} />
            <ProductTrendAnalysisWidget widgetData={moduleData} />
            <RatingsAndReviewsWidget widgetData={moduleData} />
            <ProductAnalysisWidget
                widgetData={moduleData.digitalShelf}
                title="Digital Shelf Analysis"
                type="pa-deepdive"
            />
        </WidgetModuleLayout>
    );
};

export default ProductAnalysisOverviewModule;
